<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : outStockBills.pkid > 0 ? '编辑' : '新建'"
      width="1200px"
      top="10px"
      class="packMarkDetailEdit"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="outStockBills"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="outStockBills.pkid > 0" :span="12">
          <el-form-item label="出库单号" prop="billNo">
            <el-input v-model="outStockBills.billNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户" prop="customerName">
            <el-input v-model="outStockBills.customerName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="需求时间" prop="requireDate">
            <el-input v-model="outStockBills.requireDate" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发货联系人" prop="deliveryContact">
            <el-input v-model="outStockBills.deliveryContact"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发货联系方式" prop="deliveryTel">
            <el-input v-model="outStockBills.deliveryTel"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="发货地址" prop="deliveryAddress">
            <el-input v-model="outStockBills.deliveryAddress"/>
          </el-form-item>
        </el-col>
        <el-col v-if="outStockBills.pkid > 0" :span="12">
          <el-form-item label="制单时间" prop="createTime">
            <el-input v-model="outStockBills.createTime" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="outStockBills.pkid > 0" :span="12">
          <el-form-item label="制单人" prop="creatorName">
            <el-input v-model="outStockBills.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="note">
            <el-input v-model="outStockBills.note" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle" style="margin-top: 10px">出库明细</div>
      <el-table
          class="tableBox"
          :data="outStockBills.outStockBillDetailVOS"
          border
          stripe
          height="40vh">
        <el-table-column prop="materialNo" align="left" label="物料编号" width="140"/>
        <el-table-column prop="materialName" align="left" label="物料名称" width="120"/>
        <el-table-column prop="specification" align="center" label="规格型号" width="100"/>
        <el-table-column align="center" label="要求交期" width="140" prop="deliveryDate"/>
        <el-table-column prop="locationName" align="center" label="出库仓" width="230">
          <template slot-scope="scope">
            <el-input v-model="scope.row.locationName" readonly placeholder="请选择出库仓">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="$refs.FLlocationSelect.open();setIndex(scope.$index)"/>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" align="center" label="数量" width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quantity"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="note"
            align="center"
            label="备注"
            width="200"
            show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input v-model="scope.row.note" type="textarea" autosize placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="80">
          <template v-slot="scope">
            <el-button type="danger" @click="deleteRow(scope.row,scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <warehouse-location-select ref="FLlocationSelect" @select="FLlocationSelect"/>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import WarehouseLocationSelect from "@/views/information/WarehouseLocation/WarehouseLocationSelect";
  import DeliveryNoticeDetailSelect from "@/views/SalesManage/DeliveryNotice/DeliveryNoticeDetailSelect";

  export default {
    name: "OutStockDeliveryEdit",
    components: {DeliveryNoticeDetailSelect, WarehouseLocationSelect},
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        index: 0,
        outStockBills: {
          outStockType: 2,
          pkid: 0,
          billNo: "",
          relBillNo: "",
          relBillId: "",
          requireDate: "",
          status: "",
          statusName: "",
          creatorName: "",
          createTime: "",
          note: "",
          outStockBillDetailVOS: [],
        },
        ruleValidate: {
          quantity: {required: true, trigger: "blur"},
          relBillNo: {required: true, message: "请选择关联单号", trigger: "change"},
        },
      };
    },
    methods: {
      open(id, disabled) {
        this.dialogVisible = true;
        if (id) {
          this.outStockBills.pkid = id;
          this.getData();
        }
        if (disabled) {
          this.disabled = true;
        }
      },

      // 根据出货订单id查询详细信息
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `outStockDeliverys/${this.outStockBills.pkid}`)
          .then((resp) => {
            if (resp.success) {
              this.outStockBills = Object.assign(this.outStockBills, resp.data);
              console.log(this.outStockBills);
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      setIndex(index) {
        this.index = index;
      },

      FLlocationSelect(row) {
        console.log(this.outStockBills);
        this.outStockBills.outStockBillDetailVOS[this.index].locationName = row.warehouseLocationName;
        this.outStockBills.outStockBillDetailVOS[this.index].locationId = row.pkId;
        this.outStockBills.outStockBillDetailVOS[this.index].locationNo = row.warehouseLocationNo;
        this.outStockBills.outStockBillDetailVOS[this.index].warehouseAreaName = row.warehouseAreaName;
        this.outStockBills.outStockBillDetailVOS[this.index].warehouseAreaNo = row.warehouseAreaNo;
        console.log(this.outStockBills.outStockBillDetailVOS);
      },

      deleteRow(row, index) {
        this.outStockBills.outStockBillDetailVOS.splice(index, 1);
      },

      //选择关联单号
      deliveryNoticeSelect(rows) {
        if (rows) {
          let custId = rows[0].customerId;
          rows.forEach(item => {
            if (custId !== item.customerId) {
              this.$confirm("请选择相同客户发货通知单", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
          });
          if (this.outStockBills.pkid === 0) {
            this.outStockBills.customerId = custId;
            this.outStockBills.customerNo = rows[0].customerNo;
            this.outStockBills.customerOutNo = rows[0].customerOutNo;
            this.outStockBills.customerName = rows[0].customerName;
            this.outStockBills.customerOuterNo = rows[0].customerOuterNo;
            this.outStockBills.erpSalType = rows[0].erpSalType;
            this.outStockBills.erpWorkShop = rows[0].erpWorkShop;
            this.outStockBills.RequireDate = rows[0].deliveryDate;
            this.outStockBills.deliveryContact = rows[0].deliveryContact;
            this.outStockBills.deliveryTel = rows[0].deliveryTel;
            this.outStockBills.deliveryAddress = rows[0].deliveryAddress;
          }

          rows.forEach(item => {
            if (item.quantity > item.deliveryQuantity) {
              let data = {
                materialNo: item.materialNo,
                materialName: item.materialName,
                specification: item.specification,
                quantity: item.quantity - item.deliveryQuantity,
                deliveryDate: item.requireDeliveryDate,
                note: item.note,
                refBillId: item.masterId,
                refBillNo: item.billNo,
                refRowIndex: item.rowIndex,
                rowIndex: this.rowIndex++,
                locationName: item.locationName,
                locationId: item.locationId,
                warehouseAreaNo: item.warehouseAreaNo,
                warehouseAreaName: item.warehouseAreaName,
              };
              this.outStockBills.outStockBillDetailVOS.push(data);
            }
          });
        }
      },

      getDetailData(id) {
        this.$http.get("basic", `outStockDeliverys/getDetailByTask/${id}`).then((res) => {
          if (res.success) {
            this.outStockBills.outStockBillDetailVOS = res.data;
          }
        });
      },
      // 编辑、新建
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.outStockBills.outStockBillDetailVOS.length) {
              this.$confirm("请添加出库明细", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            let flag = false;
            this.outStockBills.outStockBillDetailVOS.forEach(item => {
              if (!item.locationName) {
                flag = true;
              }
            });
            if (flag) {
              this.$confirm("请选择出库仓", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            this.submitLoading = true;
            this.$http
              .save("basic", "outStockDeliverys", this.outStockBills)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.outStockBills.pkid > 0) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.packMarkDetailEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.packMarkDetailEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.packMarkDetailEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.packMarkDetailEdit .el-divider--horizontal {
  margin: 10px 0;
}

.packMarkDetailEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
}

.tableBox .el-form-item__content {
  margin-left: 0 !important;
}

.tableBox .el-form-item {
  margin-bottom: 0;
}

.tableBox .el-input--mini .el-input__inner {
  text-align: center;
}
</style>
